import { getSize } from '@/utils/utils'

export function buildVisualReportGrid () {
  return {
    left: getSize(20),
    right: getSize(20),
    top: getSize(50),
    bottom: getSize(52),
    containLabel: true
  }
}

export function buildVisualReportDataZoom () {
  return [
    { type: 'inside', start: 0, end: 100 },
    {
      type: 'slider',
      start: 0,
      end: 100,
      height: getSize(22),
      bottom: getSize(6),
      showDetail: false
    }
  ]
}

export function buildAxisTooltipPosition () {
  return function (point, params, dom, rect, size) {
    var x = 0
    var y = 0
    var pointX = point[0]
    var pointY = point[1]
    var boxWidth = size.contentSize[0]
    var boxHeight = size.contentSize[1]
    if (boxWidth > pointX) {
      x = 5
    } else {
      x = pointX - boxWidth
    }
    if (boxHeight > pointY) {
      y = 5
    } else {
      y = pointY - boxHeight
    }
    return [x, y]
  }
}
